@if (viewportService.isMobile()) {
    <a
        class="w-full flex flex-col items-center justify-center rounded-lg cursor-pointer hover:bg-p-content-hover-background"
        [ngClass]="{
            'bg-p-content-background': menuDrawerStateService.visible(),
            '!bg-primary-50 dark:!bg-primary': link.isActive && !menuDrawerStateService.visible(),
        }"
        routerLink="/dashboard"
        routerLinkActive
        (mouseenter)="onMouseEnter()"
        (mouseleave)="onMouseLeave()"
        (click)="menuDrawerStateService.close()"
        #link="routerLinkActive"
        pTooltip="Home"
        [tooltipPosition]="'top'">
        @if (menuDrawerStateService.visible() || !link.isActive) {
            <fa-icon class="text-[20px] text-color" [icon]="faHome" />
        } @else {
            <fa-icon class="text-[20px] text-primary dark:text-white" [icon]="faHomeSolid" />
        }
    </a>
} @else {
    <a
        class="w-full flex flex-col items-center justify-center rounded-lg cursor-pointer hover:bg-p-content-hover-background bp908:hover:bg-blurple"
        [ngClass]="{ 'bp908:!bg-blurple-dark': link.isActive }"
        routerLink="/dashboard"
        routerLinkActive
        (mouseenter)="onMouseEnter()"
        (mouseleave)="onMouseLeave()"
        #link="routerLinkActive"
        pTooltip="Home"
        [tooltipPosition]="'right'">
        @if (!isHovered && !link.isActive) {
            <fa-icon
                class="text-18 text-color bp908:text-white"
                [icon]="faHome"
                [ngClass]="{
                    '!text-white': link.isActive,
                }" />
        } @else {
            <fa-icon
                class="text-18 text-color bp908:text-white"
                [icon]="faHomeSolid"
                [ngClass]="{
                    '!text-white': link.isActive,
                }" />
        }
    </a>
}
